module.exports = __webpack_public_path__ + "static/media/chart-if-you-invest-v2@4x.72340c2f.png";